import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import { brandInfo, advantages, testimonials, contactInfo } from '@/mocks/about';

const aboutJsonLd = {
  "@context": "https://schema.org",
  "@graph": [
    {
      "@type": "BreadcrumbList",
      "@id": "https://51chigua.com/about/#breadcrumb",
      "itemListElement": [
        {
          "@type": "ListItem",
          "position": 1,
          "name": "首页",
          "item": "https://51chigua.com"
        },
        {
          "@type": "ListItem",
          "position": 2,
          "name": "关于我们"
        }
      ]
    },
    {
      "@type": "Organization",
      "@id": "https://51chigua.com/about/#organization",
      "name": "51吃瓜App",
      "url": "https://51chigua.com",
      "description": "51吃瓜App成立于2020年，致力于打造国内最大、最全的娱乐资讯聚合平台。",
      "foundingDate": "2020",
      "contactPoint": {
        "@type": "ContactPoint",
        "contactType": "customer service",
        "email": "contact@51chigua.com",
        "telephone": "+86-400-888-5151",
        "availableLanguage": "Chinese"
      },
      "address": {
        "@type": "PostalAddress",
        "streetAddress": "建国路88号SOHO现代城A座",
        "addressLocality": "北京",
        "addressRegion": "朝阳区",
        "addressCountry": "CN"
      }
    },
    {
      "@type": "AboutPage",
      "@id": "https://51chigua.com/about/#webpage",
      "url": "https://51chigua.com/about",
      "name": "关于我们 - 51吃瓜App",
      "description": "51吃瓜App是国内领先的娱乐资讯聚合平台，覆盖明星爆料、网红吃瓜、社会热点，日均活跃用户超百万。了解品牌故事、平台优势与联系方式。",
      "isPartOf": {
        "@type": "WebSite",
        "@id": "https://51chigua.com/#website"
      },
      "inLanguage": "zh-CN"
    },
    {
      "@type": "FAQPage",
      "@id": "https://51chigua.com/about/#faq",
      "mainEntity": [
        {
          "@type": "Question",
          "name": "51吃瓜App是做什么的？",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "51吃瓜App是国内领先的娱乐资讯聚合平台，致力于为用户提供最新最全的明星爆料、网红吃瓜、社会热点等娱乐资讯内容。"
          }
        },
        {
          "@type": "Question",
          "name": "如何下载51吃瓜App？",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "您可以通过官方网站首页的下载入口，或在iOS App Store和各大安卓应用商店搜索51吃瓜进行下载安装。"
          }
        },
        {
          "@type": "Question",
          "name": "51吃瓜App的内容更新频率如何？",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "51吃瓜App实行24小时不间断内容更新机制，重大爆料事件可在5分钟内完成推送，确保用户第一时间获取最新资讯。"
          }
        },
        {
          "@type": "Question",
          "name": "如何联系51吃瓜App进行商务合作？",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "您可以通过发送邮件至contact@51chigua.com，或拨打客服热线400-888-5151与我们取得联系，我们将在工作时间内尽快回复。"
          }
        }
      ]
    }
  ]
};

export default function About() {
  return (
    <div className="min-h-screen bg-background-50">
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(aboutJsonLd) }}
      />
      <Navbar />
      <main className="pt-20 pb-10">
        <nav className="px-4 md:px-6 py-4 max-w-7xl mx-auto" aria-label="面包屑导航">
          <ol className="flex items-center gap-2 text-sm text-foreground-500">
            <li><Link to="/" className="hover:text-primary-600 transition-colors cursor-pointer">首页</Link></li>
            <li><i className="ri-arrow-right-s-line text-xs"></i></li>
            <li className="text-foreground-900 font-medium">关于我们</li>
          </ol>
        </nav>

        <section className="relative w-full py-16 md:py-24 overflow-hidden mb-10">
          <div className="absolute inset-0">
            <img
              src="https://readdy.ai/api/search-image?query=Abstract%20artistic%20composition%20with%20warm%20crimson%20and%20deep%20burgundy%20gradients%2C%20soft%20atmospheric%20lighting%2C%20cinematic%20dark%20mood%20with%20golden%20highlights%2C%20modern%20editorial%20style%2C%20minimalist%20abstract%20art%2C%20elegant%20sophisticated%20aesthetic%2C%20no%20text%20no%20watermark&width=1800&height=800&seq=about-hero-bg&orientation=landscape"
              alt="关于51吃瓜App"
              className="w-full h-full object-cover object-top"
            />
            <div className="absolute inset-0 bg-gradient-to-b from-black/70 via-black/50 to-black/70"></div>
          </div>
          <div className="relative z-10 max-w-7xl mx-auto px-4 md:px-6">
            <div className="flex flex-col lg:flex-row items-start lg:items-center gap-8">
              <div className="flex-1">
                <h1 className="font-heading font-black text-4xl md:text-5xl lg:text-6xl text-background-50 leading-tight">
                  {brandInfo.title}
                </h1>
                <p className="mt-4 text-background-50/60 text-base md:text-lg leading-relaxed max-w-lg">
                  {brandInfo.subtitle}
                </p>
                <a
                  href="#contact"
                  className="inline-flex items-center gap-2 mt-6 px-8 py-3 border border-background-50/30 text-background-50 font-medium text-sm rounded-full hover:bg-background-50/10 transition-all duration-300 cursor-pointer whitespace-nowrap"
                >
                  <i className="ri-mail-line"></i>
                  联系我们
                </a>
              </div>
            </div>
          </div>
        </section>

        <section className="px-4 md:px-6 py-10">
          <div className="max-w-7xl mx-auto">
            <div className="flex flex-col lg:flex-row gap-10 lg:gap-16 items-start">
              <div className="lg:w-[35%]">
                <span className="inline-block px-3 py-1 border border-primary-500/30 text-primary-600 text-xs font-medium rounded-full mb-4 whitespace-nowrap">
                  口碑之选
                </span>
                <img
                  src="https://readdy.ai/api/search-image?query=Modern%20office%20team%20collaboration%20scene%20with%20warm%20lighting%20and%20creative%20atmosphere%2C%20abstract%20artistic%20style%2C%20professional%20editorial%20photography%2C%20diverse%20team%20working%20on%20laptops%2C%20soft%20golden%20and%20amber%20tones%2C%20clean%20minimal%20composition%2C%20no%20text%20no%20watermark&width=600&height=750&seq=about-brand-img&orientation=portrait"
                  alt="51吃瓜App团队"
                  className="w-full rounded-2xl"
                />
              </div>
              <div className="lg:w-[65%]">
                <h2 className="font-heading font-black text-3xl md:text-4xl text-foreground-900 leading-tight mb-6">
                  平台简介
                </h2>
                <p className="text-foreground-600 leading-relaxed mb-4">
                  {brandInfo.description}
                </p>
                <p className="text-foreground-600 leading-relaxed mb-6">
                  我们拥有一支专业的编辑团队和强大的技术研发力量，通过人工智能算法和大数据分析，为用户提供最精准、最及时的娱乐资讯推送服务。同时，我们积极构建开放的内容生态，鼓励用户投稿和互动，让每一位吃瓜群众都能成为内容的生产者和传播者。
                </p>
                <div className="grid grid-cols-2 sm:grid-cols-4 gap-4 mt-8">
                  {[
                    { value: brandInfo.users, label: '累计用户' },
                    { value: brandInfo.articles, label: '爆料文章' },
                    { value: brandInfo.dailyActive, label: '日活用户' },
                    { value: `成立于${brandInfo.yearFounded}`, label: '品牌历史' },
                  ].map((stat) => (
                    <div key={stat.label} className="text-center p-4 rounded-xl bg-background-100">
                      <div className="font-heading font-black text-xl md:text-2xl text-primary-600">
                        {stat.value}
                      </div>
                      <div className="mt-1 text-foreground-500 text-xs">{stat.label}</div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="px-4 md:px-6 py-14 md:py-20 bg-background-100">
          <div className="max-w-7xl mx-auto">
            <div className="flex flex-col lg:flex-row lg:items-end justify-between gap-3 mb-12">
              <div>
                <h2 className="font-heading font-black text-3xl md:text-4xl text-foreground-900">
                  我们的优势
                </h2>
                <p className="mt-2 text-foreground-600">
                  为什么千万用户选择51吃瓜
                </p>
              </div>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
              {advantages.map((adv) => (
                <div
                  key={adv.title}
                  className="p-6 rounded-2xl bg-background-50 hover:bg-primary-50/50 transition-colors duration-300"
                >
                  <div className="w-12 h-12 flex items-center justify-center bg-primary-500/10 text-primary-600 rounded-xl mb-4">
                    <i className={`${adv.icon} text-2xl`}></i>
                  </div>
                  <h3 className="font-heading font-bold text-lg text-foreground-900 mb-2">
                    {adv.title}
                  </h3>
                  <p className="text-foreground-600 text-sm leading-relaxed">
                    {adv.description}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </section>

        <section className="px-4 md:px-6 py-14 md:py-20">
          <div className="max-w-4xl mx-auto">
            <div className="text-center mb-12">
              <h2 className="font-heading font-black text-3xl md:text-4xl text-foreground-900">
                用户口碑
              </h2>
              <p className="mt-2 text-foreground-600">
                听听用户们怎么说
              </p>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
              {testimonials.map((testimonial, idx) => (
                <div
                  key={idx}
                  className="p-6 rounded-2xl bg-background-100"
                >
                  <div className="flex items-center gap-3 mb-4">
                    <div className="w-11 h-11 rounded-full overflow-hidden flex-shrink-0">
                      <img
                        src={testimonial.avatar}
                        alt={testimonial.name}
                        className="w-full h-full object-cover"
                        loading="lazy"
                      />
                    </div>
                    <div>
                      <div className="font-semibold text-sm text-foreground-900">{testimonial.name}</div>
                      <div className="text-foreground-500 text-xs">{testimonial.role}</div>
                    </div>
                  </div>
                  <p className="text-foreground-600 text-sm leading-relaxed">
                    &ldquo;{testimonial.content}&rdquo;
                  </p>
                </div>
              ))}
            </div>
          </div>
        </section>

        <section id="contact" className="px-4 md:px-6 py-14 md:py-20 bg-background-100">
          <div className="max-w-4xl mx-auto">
            <div className="text-center mb-12">
              <h2 className="font-heading font-black text-3xl md:text-4xl text-foreground-900">
                联系我们
              </h2>
              <p className="mt-2 text-foreground-600">
                有任何问题或合作意向，欢迎通过以下方式联系我们
              </p>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
              {[
                { icon: 'ri-mail-line', label: '电子邮箱', value: contactInfo.email, href: `mailto:${contactInfo.email}` },
                { icon: 'ri-wechat-line', label: '微信公众号', value: contactInfo.wechat },
                { icon: 'ri-weibo-line', label: '官方微博', value: contactInfo.weibo },
                { icon: 'ri-map-pin-line', label: '公司地址', value: contactInfo.address },
                { icon: 'ri-phone-line', label: '联系电话', value: contactInfo.phone },
                { icon: 'ri-time-line', label: '工作时间', value: contactInfo.businessHours },
              ].map((item) => (
                <div key={item.label} className="p-5 rounded-2xl bg-background-50 text-center">
                  <div className="w-11 h-11 mx-auto flex items-center justify-center bg-primary-500/10 text-primary-600 rounded-xl mb-3">
                    <i className={`${item.icon} text-xl`}></i>
                  </div>
                  <h4 className="font-semibold text-sm text-foreground-900 mb-1">{item.label}</h4>
                  {item.href ? (
                    <a href={item.href} className="text-foreground-600 text-sm hover:text-primary-600 transition-colors cursor-pointer">
                      {item.value}
                    </a>
                  ) : (
                    <p className="text-foreground-600 text-sm">{item.value}</p>
                  )}
                </div>
              ))}
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}